import React from "react";

import { IdentifierVerificationDialog } from "./IdentifierVerificationDialog";
import { isRailCarNumberMatch } from "../../utils/railCarUtils";

export const RailCarNumberVerificationDialog = ({
  expectedRailCarNumber,
  close,
  onProceed,
  open,
  scanEnabled = false,
  onValidationSuccess = null,
}) => {
  const handleValidationSuccess = onValidationSuccess ?? close;

  return (
    <IdentifierVerificationDialog
      open={open}
      title="Validate Railcar Number"
      subtitle="Enter the arriving railcar number before accepting this shipment."
      fieldLabel="Railcar Number"
      expectedIdentifier={expectedRailCarNumber}
      valuesMatch={isRailCarNumberMatch}
      successNotifyMessage="Arriving railcar validated successfully."
      mismatchHelperText="Railcar number does not match. Enter the correct arriving railcar number."
      mismatchWarningNotify="Railcar number does not match. Enter the correct arriving railcar number."
      validateAriaLabel="Validate railcar number"
      inputAriaLabel="Enter railcar number"
      allowExceptionOnMismatch={Boolean(onProceed)}
      onProceedWithException={onProceed}
      scanEnabled={scanEnabled}
      onClose={close}
      onValidationSuccess={handleValidationSuccess}
    />
  );
};
